// 原始订单
// 分类
// 账户

export const Format = function(data, classifications, accounts) {
  let parseData = [];

  let classificationsObj = {
    outlayDefault: {},
    incomeDefault: {},
    transferDefault: {},
    outlay: {},
    income: {},
    transfer: {},
  };
  classifications.forEach(v => {
    switch (v.type) {
      case 0:
        classificationsObj.outlay[v.name] = v;
        if (v.system_tag == "outlay_other") classificationsObj.outlayDefault = v;
        break;
      case 1:
        classificationsObj.income[v.name] = v;
        if (v.system_tag == "income_other") classificationsObj.incomeDefault = v;
        break;
      case 2:
        classificationsObj.transfer[v.name] = v;
        if (v.system_tag == "transfer") classificationsObj.transferDefault = v;
        break;
    }
  })

  let accountsObj = {};
  accounts.forEach(v => {
    accountsObj[v.name] = v;
  })

  switch (data.type) {
    case "支付宝":
      parseData = importAlipay(data.data, classificationsObj);
      break;
    case "微信":
      parseData = importWx(data.data, classificationsObj, accountsObj);
      break;
    case "汤圆记账":
      parseData = importTangyuanjizhang(data.data, classificationsObj, accountsObj);
      break;
    case "钱迹":
      parseData = importQianji(data.data, classificationsObj, accountsObj);
      break
    case "叨叨记账":
      parseData = importDaoDao(data.data, classificationsObj, accountsObj);
      break;
    case "网易有钱":
      parseData = importYouqian(data.data, classificationsObj, accountsObj);
      break;
    case "口袋记账":
      parseData = importKoudai(data.data, classificationsObj, accountsObj);
      break;
  }
  return parseData;
}

function importAlipay(data, classifications) {
  let parseData = [];
  data.forEach(v => {
    let amount = parseFloat(v[9].replace('¥', ''));
    if (isNaN(amount) || amount <= 0) return true;

    let billingAt = new Date(v[2]);
    if (billingAt.toString() == "Invalid Date") return true;

    let type = 0;
    switch (v[10]) {
      case "支出":
        type = 0;
        break;
      case "收入":
        type = 1;
        break;
      default:
        return true;
    }

    let classification = null;
    switch (type) {
      case 0:
        classification = classifications.outlay[v[8]]
        if (classification == null) classification = classifications.outlayDefault;
        break;
      case 1:
        classification = classifications.income[v[8]]
        if (classification == null) classification = classifications.incomeDefault;
        break;
    }

    parseData.push({
      amount: amount,
      billingAt: billingAt,
      type: type,
      classification: classification,
      fromAccount: null,
      toAccount: null,
      remark: v[7] + " " + v[8],
    })
  });

  return parseData;
}

function importWx(data, classifications, accounts) {
  let parseData = [];
  data.forEach(v => {
    let amount = parseFloat(v[5].replace('¥', ''));
    if (isNaN(amount) || amount <= 0) return true;

    let billingAt = new Date(v[0]);
    if (billingAt.toString() == "Invalid Date") return true;

    let type = 0;
    switch (v[4]) {
      case "支出":
        type = 0;
        break;
      case "收入":
        type = 1;
        break;
      default:
        return true;
    }

    let classification = null;
    switch (type) {
      case 0:
        classification = classifications.outlay[v[4]]
        if (classification == null) classification = classifications.outlayDefault;
        break;
      case 1:
        classification = classifications.income[v[4]]
        if (classification == null) classification = classifications.incomeDefault;
        break;
    }

    let fromAccount = null;
    let toAccount = null;
    switch (type) {
      case 0:
        if(v[6] == "零钱") v[6] = "微信";
        fromAccount = accounts[v[6]];
        break;
    
      case 1:
        if (v[6] == "零钱") v[6] = "微信";
        toAccount = accounts[v[6]];
        break;
    }
    
    parseData.push({
      amount: amount,
      billingAt: billingAt,
      type: type,
      classification: classification,
      fromAccount: fromAccount,
      toAccount: toAccount,
      remark: v[1] + " " + v[2] + " " + (v[3] != '/' ? v[3] : ''),
    })
  });

  return parseData;
}

// 解析汤圆记账账单
function importTangyuanjizhang(data, classifications, accounts) {
  let parseData = [];
  data.forEach(v => {
    let amount = parseFloat(v[5]);
    if(isNaN(amount) || amount <= 0) return true;

    let billingAt = new Date(v[1].replace("年", "-").replace("月", "-").replace("日", ""));
    if (billingAt.toString() == "Invalid Date") return true;

    let type = 0;
    switch (v[2]) {
      case "支出":
        type = 0;
        break;
      case "收入":
        type = 1;
        break;
      case "转账":
        type = 2;
        break;
      default:
        return true;
    }

    let classification = null;
    let exC = v[4] != "" ? v[4] : v[3];
    switch (type) {
      case 0:
        classification = classifications.outlay[exC]
        if(classification == null) classification = classifications.outlayDefault;
        break;
      case 1:
        classification = classifications.income[exC]
        if (classification == null) classification = classifications.incomeDefault;
        break;
      case 2:
        classification = classifications.transfer[exC]
        if (classification == null) classification = classifications.transferDefault;
        break;
    }
    
    let fromAccount = accounts[v[6]];
    let toAccount = accounts[v[7]];

    // 转账账单未识别出账户的直接丢弃
    if(type == 2 && fromAccount == null && toAccount == null) return true;

    parseData.push({
      amount: amount,
      billingAt: billingAt,
      type: type,
      classification: classification,
      fromAccount: fromAccount,
      toAccount: toAccount,
      remark: v[8],
    })
  });

  return parseData;
}

function importQianji(data, classifications, accounts) {
  let parseData = [];
  data.forEach(v => {
    let amount = parseFloat(v[4]);
    if (isNaN(amount) || amount <= 0) return true;

    let billingAt = new Date(v[1]);
    if (billingAt.toString() == "Invalid Date") return true;

    let type = 0;
    switch (v[3]) {
      case "支出":
        type = 0;
        break;
      case "收入":
        type = 1;
        break;
      default:
        return true;
    }

    let classification = null;
    switch (type) {
      case 0:
        classification = classifications.outlay[v[2]]
        if (classification == null) classification = classifications.outlayDefault;
        break;
      case 1:
        classification = classifications.income[v[2]]
        if (classification == null) classification = classifications.incomeDefault;
        break;
    }

    let fromAccount = accounts[v[5]];
    let toAccount = accounts[v[6]];

    parseData.push({
      amount: amount,
      billingAt: billingAt,
      type: type,
      classification: classification,
      fromAccount: fromAccount,
      toAccount: toAccount,
      remark: v[7],
    })
  });

  return parseData;
}

function importDaoDao(data, classifications, accounts) {
  let parseData = [];
  data.forEach(v => {

    switch(v.type) {
      case "支出记录":
        v.data.forEach(vv => {
          let amount = parseFloat(vv["记账金额"]);
          if (isNaN(amount) || amount <= 0) return true;

          let billingAt = new Date(vv["记账日期"] + " " + vv["记账时间"]);
          if (billingAt.toString() == "Invalid Date") return true;

          let classification = classifications.outlay[vv["二级分类"]]
          if (classification == null) classification = classifications.outlayDefault;

          let fromAccount = accounts[vv["使用账户"]];

          parseData.push({
            amount: amount,
            billingAt: billingAt,
            type: 0,
            classification: classification,
            fromAccount: fromAccount,
            remark: vv["备注"],
          })
        })
        break;
      case "收入记录":
        v.data.forEach(vv => {
          let amount = parseFloat(vv["记账金额"]);
          if (isNaN(amount) || amount <= 0) return true;

          let billingAt = new Date(vv["记账日期"] + " " + vv["记账时间"]);
          if (billingAt.toString() == "Invalid Date") return true;

          let classification = classifications.income[vv["二级分类"]]
          if (classification == null) classification = classifications.incomeDefault;

          let toAccount = accounts[vv["使用账户"]];

          parseData.push({
            amount: amount,
            billingAt: billingAt,
            type: 1,
            classification: classification,
            toAccount: toAccount,
            remark: vv["备注"],
          })
        })
        break;
      case "转账记录":
        v.data.forEach(vv => {
          let amount = parseFloat(vv["记账金额"]);
          if (isNaN(amount) || amount <= 0) return true;

          let billingAt = new Date(vv["记账日期"] + " " + vv["记账时间"]);
          if (billingAt.toString() == "Invalid Date") return true;

          let classification = classifications.transfer[vv["二级分类"]]
          if (classification == null) classification = classifications.transferDefault;

          let fromAccount = null;
          let toAccount = null;
          if(vv["记账类型"] == "转出") {
            fromAccount = accounts[vv["使用账户"]];
          } else {
            toAccount = accounts[vv["使用账户"]];
          }

          parseData.push({
            amount: amount,
            billingAt: billingAt,
            type: 2,
            classification: classification,
            fromAccount: fromAccount,
            toAccount: toAccount,
            remark: vv["备注"],
          })
        })
        break;
    }
  })

  return parseData;
}

function importYouqian(data, classifications, accounts) {
  let parseData = [];
  data.forEach(v => {

    switch (v.type) {
      case "支出":
        v.data.forEach(vv => {
          let amount = parseFloat(vv["金额"]);
          if (isNaN(amount) || amount <= 0) return true;

          let billingAt = new Date(vv["时间"]);
          if (billingAt.toString() == "Invalid Date") return true;

          let classification = classifications.outlay[vv["小类"] == "" ? vv["大类"] : vv["小类"]]
          if (classification == null) classification = classifications.outlayDefault;

          let fromAccount = accounts[vv["账户"]];

          parseData.push({
            amount: amount,
            billingAt: billingAt,
            type: 0,
            classification: classification,
            fromAccount: fromAccount,
            remark: vv["备注"],
          })
        })
        break;
      case "收入":
        v.data.forEach(vv => {
          let amount = parseFloat(vv["金额"]);
          if (isNaN(amount) || amount <= 0) return true;

          let billingAt = new Date(vv["时间"]);
          if (billingAt.toString() == "Invalid Date") return true;

          let classification = classifications.income[vv["小类"] == "" ? vv["大类"] : vv["小类"]]
          if (classification == null) classification = classifications.incomeDefault;

          let toAccount = accounts[vv["账户"]];

          parseData.push({
            amount: amount,
            billingAt: billingAt,
            type: 1,
            classification: classification,
            toAccount: toAccount,
            remark: vv["备注"],
          })
        })
        break;
      case "转账":
        v.data.forEach(vv => {
          let amount = parseFloat(vv["转出金额"]);
          if (isNaN(amount) || amount <= 0) return true;

          let billingAt = new Date(vv["时间"]);
          if (billingAt.toString() == "Invalid Date") return true;

          let classification = classifications.transfer[vv["小类"] == "" ? vv["大类"] : vv["小类"]]
          if (classification == null) classification = classifications.transferDefault;

          let fromAccount = accounts[vv["转出账户"]];
          let toAccount = accounts[vv["转入账户"]];

          parseData.push({
            amount: amount,
            billingAt: billingAt,
            type: 2,
            classification: classification,
            fromAccount: fromAccount,
            toAccount: toAccount,
            remark: vv["备注"],
          })
        })
        break;
    }
  })

  return parseData;
}

// 时间	收支类型	账目分类	金额	账户	账户类型	账本	成员	备注
// 2021 / 4 / 4	支出	购入 - 10000	信用卡	信用卡	数字货币
function importKoudai(data, classifications, accounts) {
  let parseData = [];
  data.forEach(v => {

    switch (v.type) {
      case "收支记录":
        v.data.forEach(vv => {
          let amount = Math.abs(parseFloat(vv["金额"]));
          if (isNaN(amount) || amount <= 0) return true;

          let billingAt = new Date(vv["时间"]);
          if (billingAt.toString() == "Invalid Date") return true;

          let type = 0;
          switch (vv["收支类型"]) {
            case "支出":
              type = 0;
              break;
            case "收入":
              type = 1;
              break;
            default:
              return true;
          }

          let classification = null;
          switch (type) {
            case 0:
              classification = classifications.outlay[vv["账目分类"]]
              if (classification == null) classification = classifications.outlayDefault;
              break;
            case 1:
              classification = classifications.income[vv["账目分类"]]
              if (classification == null) classification = classifications.incomeDefault;
              break;
          }

          let fromAccount = accounts[vv["账户"]];

          parseData.push({
            amount: amount,
            billingAt: billingAt,
            type: type,
            classification: classification,
            fromAccount: fromAccount,
            remark: vv["备注"],
          })
        })
        break;
      case "借入借出":
        break;
      case "固收理财":
        break;
    }
  })

  return parseData;
}